var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-volume-chart"},[_c('div',{ref:"chart",staticClass:"brand-volume-chart__chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }